var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessages({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.12 17.08V8.40002H2.8C1.26 8.40002 0 9.66002 0 11.2V19.6C0 21.14 1.26 22.4 2.8 22.4H4.2V26.6L8.4 22.4H15.4C16.94 22.4 18.2 21.14 18.2 19.6V17.052C18.108 17.0718 18.0141 17.0816 17.92 17.0814H8.12V17.08ZM25.2 1.40002H12.6C11.06 1.40002 9.8 2.66002 9.8 4.20002V15.4H19.6L23.8 19.6V15.4H25.2C26.74 15.4 28 14.1414 28 12.6V4.20002C28 2.66002 26.74 1.40002 25.2 1.40002Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/Messages.d016cd8a9e6ccfdc525db6e0f2cdb3ba.svg";
export { ForwardRef as ReactComponent };